<template>
  <div class="the-navbar__user-meta flex items-center">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <b-row>
        <b-col>
          <div class="text-right leading-tight hidden sm:block" style="    width: max-content;">
            <p style="margin-bottom: 0px !important" class="font-semibold">
              {{ activeUserInfo.userName }}
            </p>
            <small>{{ activeUserInfo.userCode }}</small>
          </div>
        </b-col>
        <b-col>
          <div class="con-img ml-3">
            <img
              v-if="activeUserInfo.photoURL"
              key="onlineImg"
              :src="activeUserInfo.photoURL"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
        </b-col>
      </b-row>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <vs-dropdown-group vs-collapse :vs-label="$t('Languages')" vs-icon="add">
          <vs-dropdown-item @click="updateLocale('en')"
            ><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" />
            &nbsp;English</vs-dropdown-item
          >
          <vs-dropdown-item @click="updateLocale('tr')"
            ><img class="h-4 w-5 mr-1" src="@/assets/images/flags/tr.png" alt="tr" />
            &nbsp;Türkçe</vs-dropdown-item
          >
          <!--				<vs-dropdown-item @click="updateLocale('fr')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/fr.png"
							alt="fr" /> &nbsp;Français</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('de')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/de.png"
							alt="de" /> &nbsp;Deutsch</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('pt')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/pt.png"
							alt="pt" /> &nbsp;Русский</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('uz')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/uz.png"
							alt="uz" /> &nbsp;o'zbek</vs-dropdown-item>
					-->
        </vs-dropdown-group>
        <ul style="min-width: 14rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("Profil") }}</span>
          </li>
          <!--
					<li v-if="activeUserInfo.ROLE != 'Company'"
						class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="$router.push('/role').catch(() => { })">
						<feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
						<span class="ml-2">{{ $t('RoleDefinition') }}</span>
					</li>-->
          <li
            v-if="activeUserInfo.ROLE != 'Company'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user').catch(() => {})"
          >
            <feather-icon icon="UsersIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("UserDefinition") }}</span>
          </li>

          <!--
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => { })">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => { })">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>
-->
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("Logout") }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import I18n from "./I18n.vue";
export default {
  components: { I18n },
  data() {
    return {};
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`);
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale === "en") return { flag: "us", lang: "English" };
      else if (locale === "pt") return { flag: "br", lang: "Português" };
      else if (locale === "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale === "fr") return { flag: "fr", lang: "Français" };
      else if (locale === "de") return { flag: "de", lang: "Deutsch" };
      else if (locale === "ru") return { flag: "ru", lang: "Русский" };
      else if (locale === "uz") return { flag: "ru", lang: "o'zbek" };
    },
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("userLanguage", locale);
      this.$router.go();
      this.$store.dispatch("auth/getData").then((response) => {});
    },
    logout() {
      if (localStorage.getItem("fullFilmentTokenId")) {
        localStorage.removeItem("fullFilmentTokenId");
        this.$router.push("/login").catch(() => {});
      }
      this.$store.dispatch("auth/logout").then((response) => {
        console.log(response);
      });
    },
  },
};
</script>
